import React from 'react';
import { SvgIcon } from '@mui/material';

export default function GraphLine(props) {
  return (
    <SvgIcon width='720' height='124' viewBox='0 0 720 124' {...props}>
      <path
        d='M0.74707 123C11.8168 119.656 26.7934 118.37 53.4909 102.164C73.1959 90.2031 92.5604 81.3284 108.188 76.6983C122.841 72.357 136.188 74.3832 144.653 75.1549C150.496 75.6876 195.443 82.8718 207.164 83.6435C218.885 84.4152 241.676 87.502 274.234 80.5567C306.791 73.6115 305.869 75.4585 330.233 67.438C388.837 48.1456 433.461 2.6348 458.511 1.07229C495.627 -1.24279 512.557 52.7758 539.255 58.1776C565.952 63.5795 583.534 64.3512 601.766 55.0909C619.999 45.8305 625.859 40.4287 646.045 38.1136C666.231 35.7985 683.812 41.972 718.975 70.5247'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinejoin='round'
        vectorEffect='non-scaling-stroke'
      />
    </SvgIcon>
  );
}
